<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
html,
body,
#app,
.g-pc-layout {
  height: 100%;
  background: #F0F4F8;
}

#app {
  // min-width: 1366px;
  height: 100%;
}
</style>
